import React, { Component } from "react";
import "./../pages/Calculators.css";
import { Row, Stack } from "react-bootstrap";

interface IProps {
  id: string;
  label: any;
  value?: number;
  classes?: string;
  onChange(v: any): void;
  onBlur?(): void;
  type?: "currency" | "percentage";
}

interface IState {
  value?: number;
}

export class NumberInput extends Component<IProps, IState> {
  /**
   *
   */
  constructor(props: IProps) {
    super(props);

    this.state = { value: props.value };
  }
  componentDidUpdate(
    prevProps: Readonly<IProps>,
    prevState: Readonly<IState>,
    snapshot?: any
  ): void {
    if (this.state.value != this.props.value) {
      this.setState({ value: this.props.value });
    }
  }
  percentFormatter(v: string): string {
    var value = parseFloat(v);
    if (isNaN(value) || value === 0) return "";
    return value.toLocaleString("en-US", { useGrouping: true }) + "%";
  }
  percentToNumber(v: string): string {
    var rawValue = this.replaceAll(v, ",", "");
    var value = parseFloat(rawValue.replace("%", ""));
    if (isNaN(value) || value === 0) return "";
    return value.toString();
  }
  replaceAll(v: string, find: string, replaceWith: string): string {
    if (v.includes(find)) {
      return this.replaceAll(v.replace(find, replaceWith), find, replaceWith);
    }
    return v;
  }
  currencyFormatter(v: string): string {
    var value = parseFloat(v);
    if (isNaN(value) || value === 0) return "";
    return "€ " + value.toLocaleString("en-US", { useGrouping: true });
  }
  currencyToNumber(v: string): string {
    var rawValue = this.replaceAll(v, ",", "");
    var value = parseFloat(rawValue.replace("€ ", ""));
    if (isNaN(value) || value === 0) return "";
    return value.toString();
  }

  getType(): "currency" | "percentage" {
    return this.props.type ?? "currency";
  }

  toFormat(v: string): string {
    if (this.getType() === "percentage") {
      return this.percentFormatter(v);
    }
    return this.currencyFormatter(v);
  }
  toValue(v: string): string {
    if (this.getType() === "percentage") {
      return this.percentToNumber(v);
    }
    return this.currencyToNumber(v);
  }

  getPlaceholder(): string {
    if (this.getType() === "percentage") {
      return "0%";
    }
    return "€ 0";
  }

  getPostfix(): string | undefined {
    if (this.getType() === "percentage") {
      return "%";
    }
    return undefined;
  }

  getPrefix(): string | undefined {
    if (this.getType() === "currency") {
      return "€";
    }
    return undefined;
  }

  render() {
    return (
      <div className="calc-grid justify-left">
        <Row>
          <label className="calculator-labels" htmlFor={this.props.id}>
            {this.props.label}
          </label>
        </Row>
        <input
          id={this.props.id}
          key={this.props.id + "-input"}
          className={"number-input " + (this.props.classes ?? "")}
          type="text"
          autoComplete="off"
          pattern="[0-9]*"
          defaultValue={this.toFormat((this.props.value ?? 0).toString())}
          value={this.toFormat(this.state.value?.toString() ?? "")} //NOTE! SETTING VALUE LIKE THIS STOPS THE CURRENCY FORMATTING!!
          placeholder={this.getPlaceholder()}
          onChange={(e) => {
            var numberValue = this.toValue(e.target.value);
            e.target.value = this.toFormat(numberValue);
            this.props.onChange({ target: { value: numberValue } });
            //this.setState({value: +numberValue})
          }}
          // onChange={this.props.onChange}
          // onFocus={(e) => {
          //     e.target.value = this.toValue(e.target.value).toString()
          // }
          // }
          onBlur={(e) => {
            //e.target.value = this.toFormat(e.target.value);
            if (this.props.onBlur) this.props.onBlur();
          }}
        />
      </div>
    );
  }
}
